import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Renewal} from "@falcon/services";
import {RouteComponentProps} from "react-router-dom";

interface IAutoRenewalQuestionProps extends RouteComponentProps{
    onSave: (automaticRenewal: boolean) => void;
    ddSelected: (automaticRenewal: boolean) => void;
    renewalProposal: Renewal;
}
interface IAutoRenewalQuestionState {
    isOpen: boolean;
    changeToDirectDebit?: boolean;
    showSuccessModal: boolean;
}

export class DirectDebitProposalModal extends React.Component<IAutoRenewalQuestionProps, IAutoRenewalQuestionState> {

    constructor(props: IAutoRenewalQuestionProps) {
        super(props);

        this.state = {
            isOpen: true,
            changeToDirectDebit: undefined,
            showSuccessModal: false,
        };
    }

    public render() {
        return (
            <>
                {<Modal className="my-2 manual-renewal-modal" isOpen={this.state.isOpen} toggle={this.hideModal}>
                    <ModalHeader close={<button className="btn-close" onClick={this.hideModal}/>}/>
                    <ModalBody className="pt-0">

                        <h1 className="a-bold fs-20">You can now pay by monthly Direct Debit</h1>
                        <div>
                            <p className="mb-2 pt-4">
                                <span className="font-weight-light">You currently pay by monthly card payment, which can sometimes lead to missed payments, for example if your card expires or needs replacing.</span>
                            </p>
                        </div>
                        <div>
                            <p className="mb-2 pt-4">
                                <span className="font-weight-light"><b>Why do people choose Direct Debit?</b> Many customers prefer Direct Debit as it uses your bank details, not your card details. They rarely need updating and the Direct Debit Guarantee ensures you get a refund if an error’s made in the payment.</span>
                            </p>
                        </div>
                        <div>
                            <p className="mb-2 pt-4">
                                <span className="font-weight-light">It’s quick and easy, we just need your bank account number and sort code.</span>
                            </p>
                        </div>
                        <h2 className="padding-bottom-16 font-weight-semi-bold pt-4">How would you like to pay for your car policy??</h2>
                        <div className="input-group">
                            <div className="custom-control w-100">
                                <input
                                    className="custom-radiobutton cursor-pointer"
                                    type="radio"
                                    name="continue-monthly-card-payment"
                                    id="continue-monthly-card-payment"
                                    value={"false"}
                                    checked={this.state.changeToDirectDebit === false}
                                    onChange={this.changeToDirectDebit}
                                />
                                <label id="continue-monthly-card-payment-label"
                                       className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                       htmlFor="continue-monthly-card-payment">
                                    Stay on monthly card payment
                                </label>
                            </div>
                            <div className="custom-control w-100">
                                <input
                                    className="custom-radiobutton cursor-pointer"
                                    type="radio"
                                    name="change-to-monthly-direct-debit"
                                    id="change-to-monthly-direct-debit"
                                    value={"true"}
                                    checked={this.state.changeToDirectDebit === true}
                                    onChange={this.changeToDirectDebit}
                                />
                                <label id="driver-label"
                                       className="checkbox-label label-bg-transparent font-weight-semi-bold"
                                       htmlFor="change-to-monthly-direct-debit">
                                    Change to monthly direct debit
                                </label>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex flex-column w-100">
                            <button type="button"
                                    className="btn btn-primary btn-blue-dashboard m-auto"
                                    onClick={this.updateAutomaticRenewal}
                                    id="updateAutomaticRenewal"
                                    disabled={this.state.changeToDirectDebit === undefined}
                            >
                                {this.state.changeToDirectDebit === false ? "Save changes": "Continue"}
                            </button>
                            <button type="button"
                                    className="btn btn-white-dashboard"
                                    onClick={this.hideModal}
                                    id="cancelChanges">
                                Cancel changes
                            </button>
                        </div>

                    </ModalFooter>
                </Modal>
                }
            </>
        );
    }

    private updateAutomaticRenewal = (): void => {
        if (this.state.changeToDirectDebit === true) {
            this.props.ddSelected(true);
            this.props.history.push(`/journey/show/product/AnnualMotorInsurance/process/renewal/presetPageMonthlyCardToDD/${this.props.renewalProposal._id}`, this.props.renewalProposal)
        } else {
            this.props.onSave(this.state.changeToDirectDebit!);
            this.hideModal();
        }
    }

    private hideModal = (): void => {
        this.setState({
            isOpen: false
        });
    }

    private changeToDirectDebit = (event: any) => {
        const value: boolean = event.target.value === "true";
        this.setState({
            changeToDirectDebit: value
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/DirectDebitProposalModal.tsx